module.exports = __webpack_public_path__ + "media/images/front/event_publish_lp/flow_01-66e2570d414be0a091055def358ccb35.png";